@if (messages$ | async; as messages) {
  <div>
    @for (confMsg of messages[messageType.MSG_TYPE_CONFIRMATION]; track confMsg; let i = $index) {
      <div
        class="alert alert-success {{confMsg?.params && confMsg?.params?.styleClass ?? confMsg.params.styleClass}}"
        >
        <span class="alert-icon">
          <cx-icon [type]="iconTypes.SUCCESS"></cx-icon>
        </span>
        <span>{{ confMsg | cxTranslate }}</span>
        @if (confMsg?.params && confMsg?.params.href) {
          <span>&nbsp;</span>
        }
        @if (confMsg?.params && confMsg?.params?.href) {
          <a [href]="confMsg.params.href"
          target="_blank">{{confMsg.params.anchorText}}</a>
        }
        @if (!confMsg?.params || confMsg?.params?.hideCloseButton !== true) {
          <button
            class="close"
            type="button"
            (click)="clear(messageType.MSG_TYPE_CONFIRMATION, i)"
            >
            <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
          </button>
        }
      </div>
    }
    @for (infoMsg of messages[messageType.MSG_TYPE_INFO]; track infoMsg; let i = $index) {
      <div
        class="alert alert-info {{infoMsg?.params && infoMsg?.params?.styleClass ?? infoMsg.params.styleClass}}"
        >
        <span class="alert-icon">
          <cx-icon [type]="iconTypes.INFO"></cx-icon>
        </span>
        <span>{{ infoMsg | cxTranslate }}</span>
        @if (infoMsg?.params && infoMsg?.params.href) {
          <span>&nbsp;</span>
        }
        @if (infoMsg?.params && infoMsg?.params?.href) {
          <a [href]="infoMsg.params.href"
          target="_blank">{{infoMsg.params.anchorText}}</a>
        }
        @if (!infoMsg?.params || infoMsg?.params?.hideCloseButton !== true) {
          <button
            class="close"
            type="button"
            (click)="clear(messageType.MSG_TYPE_INFO, i)"
            >
            <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
          </button>
        }
      </div>
    }
    @for (infoMsg of messages[messageType.MSG_TYPE_WARNING]; track infoMsg; let i = $index) {
      <div
        class="alert alert-warning {{infoMsg?.params && infoMsg?.params?.styleClass ?? infoMsg.params.styleClass}}"
        >
        <span class="alert-icon">
          <cx-icon [type]="iconTypes.WARNING"></cx-icon>
        </span>
        <span>{{ infoMsg | cxTranslate }}</span>
        @if (infoMsg?.params && infoMsg?.params?.href) {
          <span>&nbsp;</span>
        }
        @if (infoMsg?.params && infoMsg?.params?.href) {
          <a [href]="infoMsg.params.href"
          target="_blank">{{infoMsg.params.anchorText}}</a>
        }
        @if (!infoMsg?.params || infoMsg?.params?.hideCloseButton !== true) {
          <button
            class="close"
            type="button"
            (click)="clear(messageType.MSG_TYPE_WARNING, i)"
            >
            <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
          </button>
        }
      </div>
    }
    @for (errorMsg of messages[messageType.MSG_TYPE_ERROR]; track errorMsg; let i = $index) {
      <div
        class="alert alert-danger {{errorMsg?.params &&  errorMsg?.params?.styleClass ?? errorMsg.params.styleClass}}"
        >
        <span class="alert-icon">
          <cx-icon [type]="iconTypes.ERROR"></cx-icon>
        </span>
        <span>{{ errorMsg | cxTranslate }}</span>
        @if (errorMsg?.params && errorMsg.params.href) {
          <span>&nbsp;</span>
        }
        @if (errorMsg?.params && errorMsg?.params?.href) {
          <a [href]="errorMsg.params.href"
          target="_blank">{{errorMsg.params.anchorText}}</a>
        }
        @if (!errorMsg?.params || errorMsg?.params?.hideCloseButton !== true) {
          <button
            class="close"
            type="button"
            (click)="clear(messageType.MSG_TYPE_ERROR, i)"
            >
            <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
          </button>
        }
      </div>
    }
  </div>
}
